import React, { useState } from 'react';
import * as LucideIcons from 'lucide-react';
import { ChevronDown } from 'lucide-react';

// Curated list of commonly-used lucide icons for assessment cards.
export const ICON_CHOICES = [
  'Leaf', 'Shield', 'ShieldCheck', 'Lock', 'Key',
  'Award', 'BarChart3', 'TrendingUp', 'Activity', 'Gauge',
  'Building2', 'Globe', 'Zap', 'Heart', 'Users',
  'Target', 'Sparkles', 'Scale', 'Lightbulb', 'FileCheck',
  'Database', 'Server', 'Cpu', 'Cloud', 'Network',
  'Briefcase', 'Landmark', 'Factory', 'Truck', 'Wrench',
  'HardHat', 'Recycle', 'TreePine', 'Droplet', 'Wind',
  'Flame', 'Sun', 'Mountain', 'Clipboard', 'FileText',
  'Star', 'Flag', 'Compass', 'Eye', 'ChartPie',
];

export default function IconPicker({ value, onChange, testIdPrefix = 'icon' }) {
  const [open, setOpen] = useState(false);
  const Current = LucideIcons[value] || LucideIcons.Leaf;

  return (
    <div className="relative">
      <button type="button" onClick={() => setOpen(!open)}
        data-testid={`${testIdPrefix}-picker-btn`}
        className="w-full flex items-center justify-between gap-2 bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-900 hover:bg-gray-50">
        <span className="flex items-center gap-2">
          <Current className="w-5 h-5 text-gray-700" />
          <span className="text-gray-700">{value || 'Choose icon'}</span>
        </span>
        <ChevronDown className="w-4 h-4 text-gray-400" />
      </button>
      {open && (
        <div className="absolute z-50 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg p-2 max-h-72 overflow-y-auto" data-testid={`${testIdPrefix}-picker-grid`}>
          <div className="grid grid-cols-6 gap-1.5">
            {ICON_CHOICES.map(name => {
              const Icon = LucideIcons[name];
              if (!Icon) return null;
              const selected = name === value;
              return (
                <button key={name} type="button"
                  onClick={() => { onChange(name); setOpen(false); }}
                  title={name}
                  data-testid={`${testIdPrefix}-option-${name}`}
                  className={`aspect-square flex items-center justify-center rounded-md border transition-colors ${selected ? 'bg-emerald-100 border-emerald-400' : 'bg-gray-50 border-transparent hover:bg-gray-100'}`}>
                  <Icon className="w-5 h-5 text-gray-700" />
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
